import { PieceJustificativeDocumentTypeEnum } from '@graphql/generated';
import { PieceJustificativeDocumentType } from '@lib/models/demande-validation-pj/types/piece-justificative-document-types.type';

export class PieceJustificativeDocumentTypeMapper {
  public static fromGraphQl(
    documentType: PieceJustificativeDocumentTypeEnum
  ): PieceJustificativeDocumentType {
    const mapping: Partial<
      Record<PieceJustificativeDocumentTypeEnum, PieceJustificativeDocumentType>
    > = {
      KBIS_PL: 'kbis_pl',
      KBIS_SOC: 'kbis_soc',
      PHOTO_IDENTITE: 'photo_identite',
      RCP: 'rcp',
      RIB_AGC: 'rib_agc',
      RIB_PL: 'rib_pl',
      RIB_SOC: 'rib_soc',
      RSAC: 'rsac',
      ATT_VIGILANCE_AGC: 'attestation_vigilance_agc',
      ATT_VIGILANCE_PL: 'attestation_vigilance_pl',
      ATT_VIGILANCE_SOC: 'attestation_vigilance_soc',
      CERFA_3558_AGC: 'cerfa_3558_agc',
      CERFA_3558_PL: 'cerfa_3558_pl',
      CERFA_3558_SOC: 'cerfa_3558_soc',
      CERFA_3666_AGC: 'cerfa_3666_agc',
      CERFA_3666_PL: 'cerfa_3666_pl',
      CERFA_3666_SOC: 'cerfa_3666_soc',
      NOTIF_AFFILIATION_AGC: 'notification_affiliation_agc',
      NOTIF_AFFILIATION_PL: 'notification_affiliation_pl',
      NOTIF_AFFILIATION_SOC: 'notification_affiliation_soc',
      AVENANT_MIF2_ALPSI: 'avenant_mif2_alpsi',
      AVENANT_MIF2_CIF: 'avenant_mif2_cif',
      CONV_DISTRIB_INVEST: 'conv_distrib_invest',
      CARTE_TRANSACTION: 'carte_transaction',
      CARTE_VITALE: 'carte_vitale',
      CONTRAT_APPRENTISSAGE: 'contrat_apprentissage',
      CNI: 'cni',
      DIPLOME: 'diplome',
      ACTE_NAISSANCE: 'acte_naissance',
      ATT_FORMATION: 'attestation_formation',
      ATT_HABILITATION_IMMO: 'attestation_habilitation_immo',
      IMMAT_ORIAS_ALPSI: 'immatriculation_orias_alpsi',
      IMMAT_ORIAS_CIF: 'immatriculation_orias_cif',
      IMMAT_ORIAS_IOB: 'immatriculation_orias_iob',
      IMMAT_ORIAS_MIA: 'immatriculation_orias_mia',
      JUSTIFICATIF_DOMICILE: 'justificatif_domicile',
      LIVRET_FAMILLE: 'livret_famille',
      MANDAT_ALPSI: 'mandat_alpsi',
      PASSEPORT: 'passeport',
      CASIER_JUDICIAIRE_B3: 'casier_judiciaire_b3',
      STATUT_SOCIETE: 'statut_societe',
      CERTIFICAT_TRAVAIL: 'certificat_travail',
      TITRE_SEJOUR: 'titre_sejour',
      FORMATION_CONTINUE_IMMO: 'formation_continue_immo',
      FORMATION_CONTINUE_ASSU: 'formation_continue_assu',
      FORMATION_CONTINUE_FIN: 'formation_continue_financement',
      SYNTHESE_COMPTE_URSSAF: 'capture_synthese_compte_urssaf',
      NOTIF_DELAI_URSSAF: 'notif_demande_delai_urssaf',
      CONT_AGENT_CO: 'contrat_agent_commercial',
    };
    const mappedType = mapping[documentType];
    if (!mappedType) {
      throw new Error(
        `Le type de pièce justificative ${documentType} n'est pas pris en charge.`
      );
    }

    return mappedType;
  }

  public static toGraphQl = (
    documentType: PieceJustificativeDocumentType
  ): PieceJustificativeDocumentTypeEnum => {
    const mapping: Record<
      PieceJustificativeDocumentType,
      PieceJustificativeDocumentTypeEnum
    > = {
      kbis_pl: PieceJustificativeDocumentTypeEnum.KbisPl,
      kbis_soc: PieceJustificativeDocumentTypeEnum.KbisSoc,
      photo_identite: PieceJustificativeDocumentTypeEnum.PhotoIdentite,
      rcp: PieceJustificativeDocumentTypeEnum.Rcp,
      rib_agc: PieceJustificativeDocumentTypeEnum.RibAgc,
      rib_pl: PieceJustificativeDocumentTypeEnum.RibPl,
      rib_soc: PieceJustificativeDocumentTypeEnum.RibSoc,
      rsac: PieceJustificativeDocumentTypeEnum.Rsac,
      attestation_vigilance_agc: PieceJustificativeDocumentTypeEnum.AttVigilanceAgc,
      attestation_vigilance_pl: PieceJustificativeDocumentTypeEnum.AttVigilancePl,
      attestation_vigilance_soc: PieceJustificativeDocumentTypeEnum.AttVigilanceSoc,
      cerfa_3558_agc: PieceJustificativeDocumentTypeEnum.Cerfa_3558Agc,
      cerfa_3558_pl: PieceJustificativeDocumentTypeEnum.Cerfa_3558Pl,
      cerfa_3558_soc: PieceJustificativeDocumentTypeEnum.Cerfa_3558Soc,
      cerfa_3666_agc: PieceJustificativeDocumentTypeEnum.Cerfa_3666Agc,
      cerfa_3666_pl: PieceJustificativeDocumentTypeEnum.Cerfa_3666Pl,
      cerfa_3666_soc: PieceJustificativeDocumentTypeEnum.Cerfa_3666Soc,
      notification_affiliation_agc:
        PieceJustificativeDocumentTypeEnum.NotifAffiliationAgc,
      notification_affiliation_pl: PieceJustificativeDocumentTypeEnum.NotifAffiliationPl,
      notification_affiliation_soc:
        PieceJustificativeDocumentTypeEnum.NotifAffiliationSoc,
      acte_naissance: PieceJustificativeDocumentTypeEnum.ActeNaissance,
      attestation_formation: PieceJustificativeDocumentTypeEnum.AttFormation,
      attestation_habilitation_immo:
        PieceJustificativeDocumentTypeEnum.AttHabilitationImmo,
      avenant_mif2_alpsi: PieceJustificativeDocumentTypeEnum.AvenantMif2Alpsi,
      avenant_mif2_cif: PieceJustificativeDocumentTypeEnum.AvenantMif2Cif,
      conv_distrib_invest: PieceJustificativeDocumentTypeEnum.ConvDistribInvest,
      carte_transaction: PieceJustificativeDocumentTypeEnum.CarteTransaction,
      carte_vitale: PieceJustificativeDocumentTypeEnum.CarteVitale,
      cni: PieceJustificativeDocumentTypeEnum.Cni,
      contrat_apprentissage: PieceJustificativeDocumentTypeEnum.ContratApprentissage,
      diplome: PieceJustificativeDocumentTypeEnum.Diplome,
      immatriculation_orias_alpsi: PieceJustificativeDocumentTypeEnum.ImmatOriasAlpsi,
      immatriculation_orias_cif: PieceJustificativeDocumentTypeEnum.ImmatOriasCif,
      immatriculation_orias_iob: PieceJustificativeDocumentTypeEnum.ImmatOriasIob,
      immatriculation_orias_mia: PieceJustificativeDocumentTypeEnum.ImmatOriasMia,
      justificatif_domicile: PieceJustificativeDocumentTypeEnum.JustificatifDomicile,
      livret_famille: PieceJustificativeDocumentTypeEnum.LivretFamille,
      mandat_alpsi: PieceJustificativeDocumentTypeEnum.MandatAlpsi,
      passeport: PieceJustificativeDocumentTypeEnum.Passeport,
      casier_judiciaire_b3: PieceJustificativeDocumentTypeEnum.CasierJudiciaireB3,
      statut_societe: PieceJustificativeDocumentTypeEnum.StatutSociete,
      certificat_travail: PieceJustificativeDocumentTypeEnum.CertificatTravail,
      titre_sejour: PieceJustificativeDocumentTypeEnum.TitreSejour,
      formation_continue_immo: PieceJustificativeDocumentTypeEnum.FormationContinueImmo,
      formation_continue_assu: PieceJustificativeDocumentTypeEnum.FormationContinueAssu,
      formation_continue_financement:
        PieceJustificativeDocumentTypeEnum.FormationContinueFin,
      capture_synthese_compte_urssaf:
        PieceJustificativeDocumentTypeEnum.SyntheseCompteUrssaf,
      notif_demande_delai_urssaf: PieceJustificativeDocumentTypeEnum.NotifDelaiUrssaf,
      contrat_agent_commercial: PieceJustificativeDocumentTypeEnum.ContAgentCo,
    };
    return mapping[documentType];
  };
}
